/**
 * utility function to extract zip code from string
 * @param str location string to extract zip code from
 * @returns zip code or empty string if not found
 */
export const extractZipCodeFromString = (str: string): string => {
  const zipCode = /\d+/g.exec(str);

  if (zipCode) {
    return zipCode[0] || '';
  }

  return '';
};
